<template>
  <div>
    <div class="SubHeaderItem">
      <b-icon v-if="icon" :icon="icon" :type="type" size="is-medium" />
      <div class="SubHeaderItem-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BIcon } from "buefy"

export default defineComponent({
  name: "SubHeaderItem",
  components: {
    BIcon,
  },
  props: {
    icon: {
      type: String,
      default: "",
      required: false,
    },
    type: {
      type: String,
      default: "",
      required: false,
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.SubHeaderItem {
  min-height: $HeaderInfo-height;
  border-color: whitesmoke;
  border-style: solid;
  border-width: 0 2px 2px 2px;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  background-color: white;
}

.SubHeaderItem-content {
  margin: 0 0.5rem;
}
</style>
